import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Typography from '../../Typography';
import ShowHide from './ShowHide';
import './referralFilters.scss';
import { Divider } from 'antd';
import COLORS from '../../../util/constants/colors';
import { withRouter } from 'react-router-dom';
import { parse } from 'qs';

/*
  This component operates on queries:
  - archived=true returns only archived referrals
  - archived=false | undefined returns only not archived referrals
  - archived=both returns both archived and not archived referrals
  - scheduled still yet to be implemented but is commented out assuming it will work the same way
*/

const ReferralFilters = ({ updateQuery, location }) => {
  const currentQuery = parse(location.search, { ignoreQueryPrefix: true });
  const [archived, setArchived] = useState(['true', 'both'].includes(currentQuery.archived));
  const [notArchived, setNotArchived] = useState(['false', 'both', undefined].includes(currentQuery.archived));
  const page = location.pathname.includes('received') ? 'Received' : 'Referrals';
  
  // RecordHOC is already loading data so we don't need to
  const firstRender = useRef(true);
  // const [scheduled, setScheduled] = useState(false);
  // const [notScheduled, setNotScheduled] = useState(true);

  // useEffect(() => {
    // if (currentQuery.scheduled === 'true') {
    //   setScheduled(true);
    //   setNotScheduled(false);
    // } else if (currentQuery.scheduled === 'false') {
    //   setScheduled(false);
    //   setNotScheduled(true);
    // }
  // }, []);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (archived === notArchived) {
      updateQuery({ ...currentQuery, archived: 'both' });
    } else {
      updateQuery({ ...currentQuery, archived });
    }
  }, [archived, notArchived, updateQuery]);

  // useEffect(() => {
  //   if (scheduled && notScheduled || !scheduled && !notScheduled) {
  //     updateQuery({ scheduled: undefined });
  //   } else if (scheduled && !notScheduled) {
  //     updateQuery({ scheduled: true });
  //   } else if (!scheduled && notScheduled) {
  //     updateQuery({ scheduled: false });
  //   }
  // }, [scheduled, notScheduled]);

  return (
    <div className='filter-referrals'>
      <Divider plain style={{ margin: '4px 0' }} />
      <div className='filter-referrals-header'>
        <div className='filter-referrals-header-title'>
          <Typography variant="text" size="medium" color={COLORS.TEXT_TERTIARY_LITE} bold>
            {page} Filters
          </Typography>
        </div>
        <div className='show-hide-header'>
          <Typography variant="text" size="small" color={COLORS.TEXT_TERTIARY_LITE} bold>
            Show
          </Typography>
          <Typography variant="text" size="small" color={COLORS.TEXT_TERTIARY_LITE} bold>
            Hide
          </Typography>
        </div>
      </div>
      <Divider plain style={{ margin: '4px 0' }} />
      <ShowHide show={archived} hideDisabled={!notArchived} setShow={setArchived} title="Archived" />
      <Divider plain style={{ margin: '4px 0' }} />
      <ShowHide show={notArchived} hideDisabled={!archived} setShow={setNotArchived} title="Not Archived" />
      {/* <Divider plain style={{ margin: '4px 0' }} />
      <ShowHide show={scheduled} setShow={setScheduled} title="Scheduled" />
      <Divider plain style={{ margin: '4px 0' }} />
      <ShowHide show={notScheduled} setShow={setNotScheduled} title="Not Scheduled" /> */}
    </div>
  );
};

ReferralFilters.defaultProps = {
  updateQuery: () => {},
  location: {},
};

ReferralFilters.propTypes = {
  updateQuery: PropTypes.func,
  location: PropTypes.object,
};

export default withRouter(ReferralFilters);
